import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

import { useOrganizations } from '@cast/shared-organization-context-data-access';

const APA_IMAGE_VULNERABILITY_REMEDIATION_REPORT_QUERY_KEY =
  'apa-image-vulnerability-remediation-report';

const getImageVulnerabilityRemediationReportQueryKey = (
  organizationId?: string
) =>
  [
    APA_IMAGE_VULNERABILITY_REMEDIATION_REPORT_QUERY_KEY,
    organizationId,
  ] as const;

const getImageVulnerabilityRemediationReportQueryOptions = ({
  organizationId,
}: {
  organizationId?: string;
}) =>
  queryOptions({
    queryKey: getImageVulnerabilityRemediationReportQueryKey(organizationId),
    queryFn: async () => {
      const { data } = await apiClient.apa.getImageVulnerabilityReport({
        organizationId: organizationId!,
      });
      return data;
    },
    enabled: !!organizationId,
  });

export const useImageVulnerabilityRemediationReportQuery = () => {
  const { currentOrganization } = useOrganizations();

  const { isLoading, data, error, refetch } = useQuery(
    getImageVulnerabilityRemediationReportQueryOptions({
      organizationId: currentOrganization?.id,
    })
  );

  return {
    isLoading,
    data,
    error,
    refetch,
  };
};
